import styled from "styled-components"
import SEARCH_SVG from "assets/images/search.svg";

interface SearchProps{
    placeholder?:string,
    value?:string,
    onChange?:(event: React.ChangeEvent<HTMLInputElement>) => void
}

const Search = ({placeholder, value, onChange}:SearchProps) => {
    return(
        <Container>
            <Input 
                placeholder={placeholder} 
                value={value} 
                onChange={onChange}
            />
            <Logo src={SEARCH_SVG} alt="search" />
        </Container>
    )
}

const Container = styled.div`
    position: relative;
    width: 100%;
    height: 48px;
    border-radius: 12px;
`

const Input = styled.input`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 48px 0 16px;
    border-radius: 12px;
    border: 1px solid #E2E8F0;
    background: #FFFFFF;
    font-size: 15px;
    color: #2D3748;
    transition: all 0.2s ease;

    &::placeholder {
        color: #A0AEC0;
    }

    &:focus {
        outline: none;
        border-color: #DF0000;
        box-shadow: 0 0 0 3px rgba(223, 0, 0, 0.12);
    }

    &:hover {
        border-color: #CBD5E0;
    }
`

const Logo = styled.img`
    position: absolute;
    top: 50%;
    right: 16px;
    width: 16px;
    height: 16px;
    transform: translateY(-50%);
    opacity: 0.5;
    transition: opacity 0.2s ease;

    ${Input}:focus + & {
        opacity: 0.8;
    }
`

export default Search;